import { getDashColor } from '../../styles'
import { DASHCOLORS } from 'bd-web-components';
import { GRAY_SCALE_06, PRIMARY_BLUE_02, PRIMARY_BLUE_03, PRIMARY_BLUE_07, SECONDARY_BLUE_01, SECONDARY_GREEN_10 } from 'bd-web-components/src/utils/dash-colors';
import styled, { css } from 'styled-components'

interface ExceptionContainerProps {
  height: number;
  margin: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1325px;
  margin-bottom: 162px;
  /* margin: 0 auto; */
  padding: 0px 64px;
  @media (max-width: 768px) {
    padding: 0px 24px;
  }
`;

export const PageTitle = styled.h4`
  color: ${DASHCOLORS.PRIMARY_BLUE_02};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 35.2px; /* 110% */
  margin-bottom: 19px;
  @media (max-width: 768px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 110% */
    margin-bottom: 13px;
  }
  `;
export const PageSubtitle = styled.p`
  color: ${DASHCOLORS.GRAY_SCALE_05};
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  @media (max-width: 768px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

export const FormDivider = styled.div`
  background-color: ${getDashColor('GRAY_SCALE_08', 'BEIGE')};
  width: 100%;
  height: 2px;
  margin-top: 29px;
  @media (max-width: 768px) {
    margin-top: 29px;
  }
`
export const InfoDivider = styled.div`
  background-color: ${getDashColor('GRAY_SCALE_08', 'BEIGE')};
  width: 100%;
  max-width: 660px;
  height: 2px;
  margin-top: 18px;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    margin-top: 15px;
    margin-bottom: 15px;
    height: 1px;
  }
`

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const GridForm = styled.div`
  /* display: grid; */
  max-width: 660px;
  margin-top: 24px;
  /* grid-template-columns: repeat(37, 1fr);
  grid-template-rows:
  72px 24px 72px 24px 72px 24px
  72px 24px 72px 24px 25px 24px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(8, 72px 24px) 25px 24px;
  } */
`
export const HorizontalContainer = styled.div`
  display: flex;
  gap: 20px;
`

export const RegistrationBox = styled.div`
  /* grid-column-start: 1;
  grid-column-end: 16;
  grid-row-start: 1;
  grid-row-end: 2;
  @media (max-width: 768px) {
    grid-column-start: 1;
    grid-column-end: 38;
  } */
    max-width: 268px;
    width: 100%;
`

export const RegistrationPixBox = styled.div`
  max-width: 290px;
  width: 100%;
`

export const OwnerBox = styled.div`
  /* grid-column-start: 17;
  grid-column-end: 38;
  grid-row-start: 1;
  grid-row-end: 2;
  @media (max-width: 768px) {
    grid-column-start: 1;
    grid-column-end: 38;
    grid-row-start: 3;
    grid-row-end: 4;
  } */
    max-width: 354px;
    width: 100%;
`

export const OwnerPixBox = styled.div`
    max-width: 375px;
    width: 100%;
`

export const TransactionTypeBox = styled.div`
  /* grid-column-start: 1;
  grid-column-end: 38;
  grid-row-start: 2;
  grid-row-end: 4;
  @media (max-width: 768px) {
    grid-column-start: 1;
    grid-column-end: 38;
    grid-row-start: 5;
    grid-row-end: 6;
  } */
    /* max-width: 375px; */
    width: 100%;
`;

export const PixTypeKeyBox = styled.div`
  max-width: 290px;
  width: 100%;
`

export const PixKeyBox = styled.div`
  max-width: 354px;
  width: 100%;
`

export const BankBox = styled.div`
  /* grid-column-start: 1;
  grid-column-end: 38;
  grid-row-start: 3;
  grid-row-end: 4;
  @media (max-width: 768px) {
    grid-column-start: 1;
    grid-column-end: 38;
    grid-row-start: 5;
    grid-row-end: 6;
  } */
    width: 100%;
`;

export const AgencyBox = styled.div`
  /* grid-column-start: 1;
  grid-column-end: 10;
  grid-row-start: 5;
  grid-row-end: 6;
  @media (max-width: 768px) {
    grid-column-start: 1;
    grid-column-end: 38;
    grid-row-start: 7;
    grid-row-end: 8;
  } */
    max-width: 161px;
    width: 100%;
`
export const AccountTypeBox = styled.div`
  /* grid-column-start: 11;
  grid-column-end: 38;
  grid-row-start: 5;
  grid-row-end: 6;
  @media (max-width: 768px) {
    grid-column-start: 1;
    grid-column-end: 38;
    grid-row-start: 9;
    grid-row-end: 10;
  } */
    max-width: 482px;
    width: 100%;
`

export const AccountNumberBox = styled.div`
  /* grid-column-start: 1;
  grid-column-end: 27;
  grid-row-start: 7;
  grid-row-end: 8;
  @media (max-width: 768px) {
    grid-column-start: 1;
    grid-column-end: 38;
    grid-row-start: 11;
    grid-row-end: 12;
  } */
    max-width: 464px;
    width: 100%;
`

export const DigitBox = styled.div`
  /* grid-column-start: 28;
  grid-column-end: 38;
  grid-row-start: 7;
  grid-row-end: 8;
  @media (max-width: 768px) {
    grid-column-start: 1;
    grid-column-end: 38;
    grid-row-start: 13;
    grid-row-end: 14;
  } */
    max-width: 179px;
    width: 100%;
`
export const AccountIdentifierBox = styled.div`
  /* grid-column-start: 1;
  grid-column-end: 38;
  grid-row-start: 9;
  grid-row-end: 10;
  @media (max-width: 768px) {
    grid-column-start: 1;
    grid-column-end: 38;
    grid-row-start: 15;
    grid-row-end: 16;
  } */
    width: 100%;
`



export const ButtonsGridBox = styled.div`
  display: grid;
  max-width: 660px;
  grid-template-columns: repeat(33, 1fr);
  grid-template-rows: 50px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: 50px 15px 50px;
  }
`;

export const GoAHeadButtonBox = styled.div`
  grid-column-start: 16;
  grid-column-end: 34;
  grid-row-start: 1;
  grid-row-end: 2;
  @media (max-width: 768px) {
    grid-column-start: 1;
    grid-column-end: 34;
    grid-row-start: 1;
    grid-row-end: 2;
  }
`
export const ReturnButtonBox = styled.div`
  grid-column-start: 1;
  grid-column-end: 15;
  grid-row-start: 1;
  grid-row-end: 2;
  @media (max-width: 768px) {
    grid-column-start: 1;
    grid-column-end: 34;
    grid-row-start: 3;
    grid-row-end: 4;
  }
`

export const ButtonsBox = styled.div`
  width: 100%;
  max-width: 660px;
  display: flex;
  display: none;
  flex-direction: row-reverse;
  justify-content: space-between;
  @media (max-width: 768px) {
    flex-direction: column;
    max-width: 100%;
    height: 110px;
    display: none;
  }
`

export const FirstStepButtonBox = styled.div`
  width: 200px;
  @media (max-width: 768px) {
    max-width: 100%;
  }
`

export const PageHeaderBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    max-width: 100%;
  }
`

export const TextHeaderBox = styled.div`
  width: 70%;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const ButtonHeaderBox = styled.div`
  width: 30%;
  display: flex;
  justify-content: flex-end;
  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    justify-content: flex-start;
  }
`
export const SaveButtonWidthControl = styled.div`
    width: 379px;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const ExceptionContainer = styled(styled.div``) <ExceptionContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  ${props => props.height !== undefined && css`
    height: ${props.height}px;
  `}
  ${props => props.margin && css`
    margin-bottom: 100px;
  `}
`

export const AvaliableMoneyBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  display: flex;
  width: 347px;
  margin-bottom: 34px;
  @media(max-width: 762px) {
    width: 100%;
    margin-bottom: 28px;
  }
`
export const AvaliableInputBox = styled.div`
  width: 347px;
  @media(max-width: 762px) {
    width: 100%;
    margin-bottom: 28px;
  }
`

export const SelectedAccountBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 660px;
  @media(max-width: 762px) {
    width: 100%;
  }
`
export const SelectedAccountField = styled.div`
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 19.6px;
  @media(max-width: 762px) {
color: ${PRIMARY_BLUE_07};
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: normal;
  }
`
export const SelectedAccountInfo = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22.4px;
  @media(max-width: 762px){
    color: ${PRIMARY_BLUE_02};
    text-align: right;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`

export const StepInfo = styled.p`
  color: ${PRIMARY_BLUE_07};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22.4px;
  margin-bottom: 18px;
@media(max-width: 762px) {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 19.6px;
  margin-bottom: 8px;
}
`

export const AddAccountBox = styled.div`
  border: 1.2px solid ${getDashColor('GRAY_SCALE_09', 'BEIGE')};
  background: var(--Branco, #FFF);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  width: 660px;
  height: 84px;
  flex-shrink: 0;
  margin-top: 24px;
  padding: 20px;
  border-radius: 5px;
  cursor: pointer;
  @media(max-width: 762px) {
    padding: 11px;
    width: 100%;
    height: 71px;
    flex-shrink: 0;
    border-radius: 5px;
  }
`

export const AddPixAccountBox = styled.div`
  border: 1.2px solid ${getDashColor('GRAY_SCALE_09', 'BEIGE')};
  background: var(--Branco, #FFF);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  width: 660px;
  height: 84px;
  flex-shrink: 0;
  margin-top: 16px;
  margin-bottom: 32px;
  padding: 20px;
  border-radius: 5px;
  cursor: pointer;
  @media(max-width: 762px) {
    padding: 11px;
    width: 100%;
    height: 71px;
    flex-shrink: 0;
    border-radius: 5px;
  }
`

export const PixIcon = styled.img`
  display: block;
`

export const IconPixContainer = styled.div`
  margin-right: 24px;
`
export const AddAccountTextBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  width: 70%;
  @media(max-width: 762px) {
    width: 70%;
  }
`
export const AddAccountArrowBox = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 10%;
  flex-grow: 1;
  @media(max-width: 762px) {
    width: 10%;
  }
`

export const AddAccountTitle = styled.p`
  color: ${PRIMARY_BLUE_03};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22.4px;
  @media(max-width: 762px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`
export const AddAccountSub = styled.p`
  color: ${GRAY_SCALE_06};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 13.6px;
  @media(max-width: 762px) {
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 13.6px;
  }
`
export const AddAccountIconBox = styled.div`
  width: 20%;
  max-width: 51px;
  height: 51px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${SECONDARY_GREEN_10};
  border-radius: 50px;
  margin-right: 20px;
  @media(max-width:762px) {
    width: 20%;
    max-width: 30px;
    height: 30px;
    flex-shrink: 0;
    margin-right: 10px;
  }
`

export const StepTitleText = styled.p`
  color: ${PRIMARY_BLUE_02};
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  @media(max-width: 762px) {
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 22.4px;
  }
`
export const TermsAndConditionInput = styled(styled.input``)`
  border-radius: 5px;
  width: 22px;
  height: 22px;
  cursor: pointer;
  @media(max-width: 762px) {
    width: 20px;
    height: 20px;
  }
`
export const TermsAndConditionTextBox = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 10px;
  flex: 1;
`
export const TermsAndConditionText = styled(styled.p``)`
  color: ${PRIMARY_BLUE_07};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22.4px;
  flex: 1;
  @media(max-width: 762px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`
export const TermsAndConditionLabel = styled.div`
  color: ${PRIMARY_BLUE_07};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22.4px;
  grid-column-start: 1;
  grid-column-end: 34;
  grid-row-start: 11;
  grid-row-end: 12;
  display: flex;
  align-items: center;
  width: 100%;
  @media(max-width: 762px) {
    grid-column-start: 1;
    grid-column-end: 34;
    grid-row-start: 17;
    grid-row-end: 18;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`

export const TermsAndConditionLink = styled(styled.strong``) <any>`
  color: ${SECONDARY_BLUE_01};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22.4px;
  cursor: pointer;
  @media(max-width: 762px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`

export const ReasonAndDescriptionBox = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
export const ReasonBox = styled.div`
  margin-right: 20px;
  flex-grow: 1;
  width: 350px;
  max-width: 350px;
  @media (max-width: 768px) {
    max-width: 100%;
    margin-right: 0px;
  }
`;

export const DescriptionBox = styled.div`
  flex-grow: 1;
`;

export const SelectedAccountInfoBox = styled.div`
  width: 660px;
  margin-bottom: 10px;
  @media(max-width: 762px) {
    width: 100%;
  }
`